import axios from 'axios';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { GET_ACTION_HISTORY } from '../constants/ActionHistory';
import { env } from 'configs/EnvironmentConfig';
import { setActionHistory } from '../actions/ActionHistory';
import { errorHandler } from 'auth/FetchInterceptor';

export function* fetchActionHistory() {
  yield takeLatest(GET_ACTION_HISTORY, function* ({ params }) {
    try {
      const response = yield call(() => {
        return axios.request({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/action-histories',
          data: {
            Rows: Object.keys(params).includes('rows') ? params.rows : 10,
            Page: Object.keys(params).includes('page') ? params.page : 1,
            Search: params.search,
          },
          withCredentials: true,
        });
      });
      const { data: actionHistory } = response;
      yield put(setActionHistory(actionHistory));
    } catch (error) {
      errorHandler(error, 'Failed to fetch action history');
    }
  });
}

export default function* rootSaga() {
  yield all([fork(fetchActionHistory)]);
}
